module.exports = __webpack_public_path__ + "static/media/darkness-les.78b277ad.png";